import UnsubscribeForm from "./UnsubscribeForm.js";

export default UnsubscribeForm;
